import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class CrmService {
  API_URL = environment.apiURL + 'crm_data';

  constructor(private httpClient: HttpClient) { }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  sendFormHomeBeca(beca): Observable<any> {
    return this.httpClient.post<any>(environment.apiURL + 'codigo_descuentos/register', JSON.stringify(beca), this.httpOptions)
      .pipe(retry(1));
  }
  getBecaByCI(ci): Promise<any> {
    const url = environment.apiURL + 'codigo_descuentos/ci' + '/' + ci;
    return this.httpClient.get<any>(url).toPromise().catch((err) => {
    });
  }
  getByFechaProcess(from, to, pageSize, currentPage): Observable<any> {
    return this.httpClient.get<any[]>(this.API_URL + '/getByFechaProcess?desde=' + from + '&hasta=' + to + '&size=' + pageSize + '&page=' + currentPage);
  }

  export(from, to): Observable<any> {
    return this.httpClient.get<any[]>(this.API_URL + '/export?desde=' + from + '&hasta=' + to);
  }

  update(data, id) {
    const url = this.API_URL + '/' + id;
    return this.httpClient.put<any>(url, data, this.httpOptions);
  }
  delete(id) {
    const url = this.API_URL + '/' + id;
    return this.httpClient.delete<any>(url);
  }
  create(data): Observable<any> {
    return this.httpClient.post<any>(this.API_URL, data, this.httpOptions);
  }

  dataProcessAll(): Observable<any> {
    const url = environment.apiURL + 'crm_data_process_execution';
    return this.httpClient.get<any[]>(url);
  }

  dataProcessUpdate(data, id) {
    const url = environment.apiURL + 'crm_data_process_execution' + '/' + id;
    return this.httpClient.put<any>(url, data);
  }
  dataProcessDelete(id) {
    const url = environment.apiURL + 'crm_data_process_execution' + '/' + id;
    return this.httpClient.delete<any>(url);
  }
  dataProcessCreate(data): Observable<any> {
    return this.httpClient.post<any>(environment.apiURL + 'crm_data_process_execution', data);
  }
  dataProcess(): Observable<any> {
    return this.httpClient.get<any>(this.API_URL + '/' + 'procesar_datos');
  }

  systemParametersAll(): Observable<any> {
    const url = environment.apiURL + 'system_parameter';
    return this.httpClient.get<any[]>(url);
  }
  systemParameterUpdate(data, id) {
    const url = environment.apiURL + 'system_parameter' + '/' + id;
    return this.httpClient.put<any>(url, data);
  }
  systemParameterDelete(id) {
    const url = environment.apiURL + 'system_parameter' + '/' + id;
    return this.httpClient.delete<any>(url);
  }
  systemParameterCreate(data): Observable<any> {
    return this.httpClient.post<any>(environment.apiURL + 'system_parameter', data);
  }

  dictionaryAll(): Observable<any> {
    const url = environment.apiURL + 'dictionary';
    return this.httpClient.get<any[]>(url);
  }
  dictionaryUpdate(data, id) {
    const url = environment.apiURL + 'dictionary' + '/' + id;
    return this.httpClient.put<any>(url, data);
  }
  dictionaryDelete(id) {
    const url = environment.apiURL + 'dictionary' + '/' + id;
    return this.httpClient.delete<any>(url);
  }
  dictionaryCreate(data): Observable<any> {
    return this.httpClient.post<any>(environment.apiURL + 'dictionary', data);
  }



  //
  // Error handling
  handleError(error): any {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
